import { useMutation, useQueryClient } from "@tanstack/vue-query";
import BusinessProfileService from "@/services/organization/business-profile";
import { UpsertBusinessProfile } from "@/dtos/BusinessProfile.dto";

export function useUpdateBusinessProfile() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (dto: UpsertBusinessProfile) => {
      const result = await BusinessProfileService.upsertBusinessProfile(dto);
      if (result.data?.status === false) {
        throw new Error(result.data.msg || "Failed to save business profile");
      }
      return result.data?.data ?? result.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["businessProfile"] });
    },
  });
}
